/* eslint-disable no-unused-vars */

import React, { Fragment, useContext, useState, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { object, bool, array } from 'prop-types'
import { stripUnit } from 'polished'

import useQueryParams from 'hooks/useQueryParams'

import { SETTINGS_FOR_PRODUCT_NAME } from 'utils/constants'
import { availableForSale } from 'utils/products'

import { H3, H4, fontSizes, fontWeights } from 'styles/typography'
import { media } from 'styles/media'
import { borderRadius } from 'styles/global'
import { borderColor, white, offWhite, black } from 'styles/colors'
import * as spacing from 'styles/spacing'

import CheckoutContext from 'contexts/Checkout'
import NativeAuthContext from 'components/NativeAuth'
import QuantityPicker from 'components/QuantityPicker'
import Chrome from 'components/buy/BuyChrome'
import BuyOverview from 'components/buy/BuyOverview'
import Summary from 'components/CartridgePage/Summary'
import BuyDevices from 'components/buy/BuyDevices'

const Heading = styled(H3)`
  border-bottom: 1px solid ${borderColor};
  text-align: center;
  padding: ${spacing.medium} ${spacing.large};
  margin-top: -${spacing.large};
  margin-left: -${spacing.large};
  margin-right: -${spacing.large};
  margin-bottom: ${spacing.large};
`

const Selector = styled.div`
  padding-top: ${spacing.large};
  margin-top: ${spacing.large};
  border-top: 1px solid ${borderColor};

  ${media.large`
    padding-top: ${spacing.xLarge};
    margin-top: ${spacing.xLarge};
  `};

  ${media.xLarge`
    padding-top: ${spacing.xxLarge};
    margin-top: ${spacing.xxLarge};
  `};
`

const SelectorHeading = styled(H4)`
  font-weight: ${fontWeights.regular};
  margin-bottom: ${spacing.medium};

  ${media.large`
    margin-bottom: ${spacing.large};
  `};
`

const Row = styled.div`
  ${media.small`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `};
`

const Quantity = styled.div`
  margin-top: ${spacing.medium};

  ${media.small`
    margin-top: 0;
  `};
`

const ProductPage = ({ product }) => {
  const { addLineItemsToCart, setTinyCartVisible, user, products } = useContext(CheckoutContext)
  const { province } = useContext(NativeAuthContext)

  const [quantity, setQuantity] = useState(0)
  const [loading, setLoading] = useState(false)
  const [selectedVariant, setSelectedVariant] = useState(product.variants[0])
  const [price, setPrice] = useState(0)

  const fetchedProduct = products.find(p => product.id.includes(p.shopifyGid))
  const fetchedVariant = fetchedProduct?.variants.find(v => v.sku === selectedVariant.sku)

  useEffect(() => {
    setPrice(selectedVariant.price * quantity)
  }, [quantity])

  const photosSrc = product.images.map(i => {
    return { originalSrc: i.originalSrc }
  })

  const handleSubmit = async () => {
    setLoading(true)

    let lineItems = [
      {
        variantId: selectedVariant.id,
        quantity: quantity,
        name: selectedVariant.title,
        price,
        product,
        variant: selectedVariant,
        title: selectedVariant.title
      }
    ]

    await addLineItemsToCart(lineItems, { silent: true })
    setTinyCartVisible(true)
    setTimeout(() => {
      setTinyCartVisible(false)
    }, 5000)
    setQuantity(0)
    setLoading(false)
  }

  const handleQuantityChange = (value, title) => {
    setQuantity(quantity + value)
  }

  const handleVariantSelect = variantId => {
    setSelectedVariant(product.variants.find(variant => variant.id === variantId))
  }

  let backgroundSrc
  if (product.handle === 'the-pouch') {
    backgroundSrc = `${process.env.BASE_PATH}/images/accessories/background/${selectedVariant.title.toLowerCase()}.jpg`
  } else if (product.handle === 'epod-charger') {
    backgroundSrc = `${process.env.BASE_PATH}/images/accessories/background/epod-charger.jpg`
  } else if (product.handle === 'holographic') {
    backgroundSrc = `${process.env.BASE_PATH}/images/accessories/background/clear.jpg`
  }

  return (
    <>
      <Chrome
        photos={[{ ...selectedVariant.image }]}
        backgroundSrc={backgroundSrc}
        summary={
          <Summary handleSubmit={handleSubmit} loading={loading} disabled={loading || quantity === 0} price={price} />
        }
      >
        <Heading className="u-hide-medium-up">{product.title}</Heading>

        <BuyOverview title={product.title} description={product.description} isCartridge />
        <Selector>
          <SelectorHeading>Choose your {product.variants.length > 1 ? 'colour' : 'quantities'}</SelectorHeading>
          <Row>
            {product.variants.length > 1 && (
              <BuyDevices
                devices={[product]}
                collectionTitle={product.title}
                handleDeviceSelect={handleVariantSelect}
                selectedVariantId={selectedVariant.id}
              />
            )}
            <Quantity>
              <QuantityPicker
                onChange={handleQuantityChange}
                value={quantity}
                title={selectedVariant.title}
                isAvailableForSale={availableForSale({ variant: fetchedVariant, province })}
              />
            </Quantity>
          </Row>
        </Selector>

        {/* <Selector variants={cartridge.variants} productHandle={cartridge.handle} setVariants={setVariants} /> */}
      </Chrome>
    </>
  )
}

ProductPage.propTypes = {
  cartridge: object.isRequired
}

export default ProductPage
